/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rd_Err_GenericInputs */

const en_rd_err_generic = /** @type {(inputs: Rd_Err_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not read that repository. Try again.`)
};

const id_rd_err_generic = /** @type {(inputs: Rd_Err_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Repo itu tidak bisa dibaca. Coba lagi.`)
};

/**
* | output |
* | --- |
* | "Could not read that repository. Try again." |
*
* @param {Rd_Err_GenericInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const rd_err_generic = /** @type {((inputs?: Rd_Err_GenericInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rd_Err_GenericInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_rd_err_generic(inputs)
	return en_rd_err_generic(inputs)
});